import React from "react";
import "../styles/ServicesPage.css";
import Services from "../components/Services";

const ServicesPage = () => {
  return (
    <div className="services-page">
      <Services />
    </div>
  );
};

export default ServicesPage;
